import { faCopy, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'components/buttons'
import { Checkbox } from 'components/form/checkbox'
import { Spinner } from 'components/loaders'
import { useTranslation } from 'react-i18next'
import { twJoin } from 'tailwind-merge'

interface Props {
  confirmedCopy: boolean
  highlightConfirmation: boolean
  onConfirmCopy: (confirmed: boolean) => void
  onCopy?: () => void
  onClose: () => void
  token?: string
}

export const CreatedApiKeyModalContent = ({
  onCopy,
  highlightConfirmation,
  confirmedCopy,
  onConfirmCopy,
  onClose,
  token,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-4 text-left grow-0 p-6 max-w-[400px]">
      <div className="flex flex-row items-center gap-4">
        <FontAwesomeIcon icon={faTriangleExclamation} />
        <span>{t('features.settings.saveApiKeyWarning')}</span>
      </div>
      {!token ? (
        <Spinner />
      ) : (
        <code className="bg-neutral-100 rounded border border-neutral-200 p-4 text-left text-wrap break-all">
          {token}
          <Button
            className="p-0 mt-2 mb-0 text-primary-600"
            variant="text"
            onClick={() => {
              void navigator.clipboard.writeText(token)
              onCopy?.()
            }}
          >
            <FontAwesomeIcon icon={faCopy} />
            {t('features.settings.copyApiKey')}
          </Button>
        </code>
      )}
      <label
        className={twJoin(
          'flex flex-row items-center gap-2',
          highlightConfirmation && 'text-error-500 font-bold',
        )}
      >
        <Checkbox
          checked={confirmedCopy}
          onChange={() => onConfirmCopy(!confirmedCopy)}
        />
        {t('features.settings.confirmApiKeySaved')}
      </label>
      <Button
        variant="outlined"
        className="max-w-max self-end"
        onClick={onClose}
        disabled={!confirmedCopy}
      >
        {t('common.close')}
      </Button>
    </div>
  )
}
